import { useCallback, useMemo } from 'react';
import { Link } from 'react-router';

import { useMenu } from 'widgets/NavigationPanel/ui/hooks/useMenu.tsx';

import { TUser } from 'entities/User';

import SvgLogoShort from 'shared/assets/logo-short-white.svg';

import cls from './NavigationPanel.module.scss';
import { MenuGroup } from './hooks/menu.types';
import { Account } from './ui/Account/Account';
import { NavigationGroupItems } from './ui/NavigationGroupItems/NavigationGroupItems';
import { NavigationGroups } from './ui/NavigationGroups/NavigationGroups';

export function NavigationPanel({ currentUser }: { currentUser: TUser }) {
  const { menu, currentGroup, setCurrentGroup } = useMenu(currentUser);

  const handleChangeGroup = useCallback(
    (group: MenuGroup) => {
      setCurrentGroup(group.title);
    },
    [setCurrentGroup],
  );

  const userData = useMemo(() => {
    return JSON.parse(localStorage.getItem('USER_DATA') || '{}');
  }, []);

  const groupItems = useMemo(() => {
    const found = menu.find((group) => group.title === currentGroup);
    if (!found) throw new Error('Group not found');

    return found.children;
  }, [menu, currentGroup]);

  return (
    <div className={cls.NavigationPanel}>
      <div>
        <div className={cls.Logotype}>
          <Link to='/' className={cls.LogotypeLink}>
            <img src={SvgLogoShort} alt='ЕРП - Единый Реестр Перевозчиков' />
          </Link>
        </div>

        <NavigationGroups
          groups={menu}
          currentGroup={currentGroup}
          onChangeGroup={handleChangeGroup}
        />

        <NavigationGroupItems items={groupItems} />
      </div>

      <div>
        <div className={cls.Footer}>
          <div style={{ padding: '12px', width: '100%' }}>
            {/* <Button variant='contained' color='neutral' size='large' fullWidth>
              Сгенерировать маркировки
            </Button> */}
          </div>
          <Account accountDetails={userData} />
        </div>
      </div>
    </div>
  );
}
